<form [formGroup]="FeeForm">
    <div class="card-body">
        <div class="col-sm-12 text-center">
            <div class="bc d-flex align-items-center pl-3">
                <img alt="Logo" src="../../assets/images/receipt.png" class="mh-45px pb-2">
                <div class="ml-2">
                    <h2 class="main-content-label mb-1 ml-2"><b>{{Certificate}} Fees</b></h2>
                </div>
            </div>
        </div>
        <div class="row clearfix">
            <div *ngIf="!Transcript && !isVerification" class="table-responsive table-container mt-4 ">
                <table id="datatable" class="table table-bordered text-nowrap">
                    <thead>
                        <tr>
                            <th width="20%" class="f600">Head</th>
                            <th width="20%" class="f600">Head Name</th>
                            <th width="20%" class="f600">Fee Amount</th>
                        </tr>
                    </thead>

                    <tbody id="table_data" formArrayName="feeHeadArray">
                        <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last "
                            [formGroupName]="i">
                            <td>
                                <input class="form-control  input-sm" readonly formControlName="FeeHead" maxlength="8"
                                    id="addone">
                            </td>
                            <td>
                                <input class="form-control input-sm" formControlName="HeadName" readonly>
                            </td>
                            <td *ngIf="ExamCurrency == 'INR' ">
                                <span class="currency-symbolTd">&#8377; </span>
                                <input class="form-control mrrr input-sm" formControlName="FeeAmt" readonly>
                            </td>
                            <td *ngIf="ExamCurrency == 'USD' ">
                                <span class="currency-symbolTd">$</span>
                                <input class="form-control mrrr input-sm" formControlName="FeeAmt" readonly>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div *ngIf="Transcript && (TranscriptData || VodData)" class="table-responsive table-container mt-4 ">
                <table *ngIf="tableData.length > 0" id="datatable" class="table table-bordered text-nowrap">
                    <thead>
                        <tr>
                            <th width="20%" class="f600">Fee Head</th>
                            <th width="20%" class="f600 hidden">Head Name</th>
                            <th class="f600 nowidth">Fee Amount</th>
                        </tr>
                    </thead>

                    <tbody id="table_data" formArrayName="feeHeadArray">
                        <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last; let row of tableData"
                            [formGroupName]="i" [class.head]="isHead(row)" [class.subhead]="isSubhead(row)">
                            <!-- Column 1 -->
                            <td>
                                <input [class.indented]="isSubhead(row)" [class.head]="isHead(row)"
                                    class="form-control input-sm" readonly formControlName="FeeHead" maxlength="50"
                                    id="addone" />
                            </td>
                            <!-- Column 2 (Hidden) -->
                            <td class="hidden">
                                <input [class.indented]="isSubhead(row)" class="form-control input-sm"
                                    formControlName="HeadName" readonly />
                            </td>
                            <!-- Column 3 (Fee Amount - INR) -->
                            <td *ngIf="ExamCurrency === 'INR'">
                                <span class="currency-symbolTd">&#8377;</span>
                                <input [class.indented]="isSubhead(row)" [class.head]="isHead(row)"
                                    class="form-control mrrr input-sm" formControlName="FeeAmt" readonly />
                            </td>

                            <!-- Column 4 (Fee Amount - USD) -->
                            <td *ngIf="ExamCurrency === 'USD'">
                                <span class="currency-symbolTd">$</span>
                                <input [class.indented]="isSubhead(row)" [class.head]="isHead(row)"
                                    class="form-control mrrr input-sm" formControlName="FeeAmt" readonly />
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <!-- Transcript Details -->
                <div *ngIf="!isAttestation && !isVerification">
                    <ul>
                        <li>Transcript No. Of Set : {{TranscriptData.StuCertCopies}}</li>
                        <li>Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' :
                            (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Both Hard Copy and Soft Copy')}}</li>
                    </ul>
                    <ul>Extra Charges:
                        <li>2190/- per set for transcript.</li>
                        <li>2570/- postal charge (Hard Copy & Out Of India Only).</li>
                    </ul>
                </div>

                <!-- Attestation Details -->
                <div *ngIf="isAttestation && TranscriptData">
                    <ul>
                        <li>Attestation : {{TranscriptData.StuCertCopies}} sets (Base for 7 sets)</li>
                        <li>Delivery Option : {{TranscriptData.DeliveryOpt == 'Hard' ? 'Hard Copy' :
                            (TranscriptData.DeliveryOpt == 'Soft' ? 'Soft Copy' : 'Both Hard Copy and Soft Copy')}}</li>
                    </ul>
                </div>

                <!-- Verification Details -->
                <div *ngIf="isVerification && VodData">
                    <ul>
                        <li>Delivery Option : {{VodData?.DeliveryOpt == 'Hard' ? 'By Air Mail Charges' :
                            (VodData?.DeliveryOpt == 'Soft' ? 'By Email Charges' : 'By Air Mail Charges and By Email Charges')}}</li>
                        <li *ngIf="VodData?.DeliverAt">Delivery Location : {{VodData?.DeliverAt == 'IN' ? 'Within India' : 'Out Of India'}}</li>
                    </ul>
                    <ul>Fee Breakdown:
                        <li>Verification Fee: ₹3050</li>
                        <!-- <li *ngIf="VodData?.StuCertCopies > 0">Additional document fee: ₹800 per set ({{VodData?.StuCertCopies}} set{{VodData?.StuCertCopies > 1 ? 's' : ''}})</li> -->
                        <li *ngIf="VodData?.DeliveryOpt == 'Soft' || VodData?.DeliveryOpt == 'Both'">By Email Charges: ₹800</li>
                        <li *ngIf="!isStudentWithinIndia() && (VodData?.DeliveryOpt == 'Hard' || VodData?.DeliveryOpt == 'Both')">By Air Mail Charges: ₹2570</li>
                        <li *ngIf="isStudentWithinIndia() && (VodData?.DeliveryOpt == 'Hard' || VodData?.DeliveryOpt == 'Both')">By Air Mail Charges: Not Applicable (Within India)</li>
                    </ul>
                </div>
            </div>

            <div *ngIf="isVerification && !VodData" class="table-responsive table-container mt-4">
                <table *ngIf="tableData.length > 0" id="datatable" class="table table-bordered text-nowrap">
                    <thead>
                        <tr>
                            <th width="20%" class="f600">Fee Head</th>
                            <th width="20%" class="f600 hidden">Head Name</th>
                            <th class="f600 nowidth">Fee Amount</th>
                        </tr>
                    </thead>
                    <tbody id="table_data" formArrayName="feeHeadArray">
                        <tr *ngFor="let fee of getfeeHeadArrayControls(); let i = index; let last = last; let row of tableData"
                            [formGroupName]="i" [class.head]="isHead(row)" [class.subhead]="isSubhead(row)">
                            <td>
                                <input [class.indented]="isSubhead(row)" [class.head]="isHead(row)"
                                    class="form-control input-sm" readonly formControlName="FeeHead" maxlength="50" id="addone" />
                            </td>
                            <td class="hidden">
                                <input [class.indented]="isSubhead(row)" class="form-control input-sm"
                                    formControlName="HeadName" readonly />
                            </td>
                            <td *ngIf="ExamCurrency === 'INR'">
                                <span class="currency-symbolTd">&#8377;</span>
                                <input [class.indented]="isSubhead(row)" [class.head]="isHead(row)"
                                    class="form-control mrrr input-sm" formControlName="FeeAmt" readonly />
                            </td>
                            <td *ngIf="ExamCurrency === 'USD'">
                                <span class="currency-symbolTd">$</span>
                                <input [class.indented]="isSubhead(row)" [class.head]="isHead(row)"
                                    class="form-control mrrr input-sm" formControlName="FeeAmt" readonly />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <ul>
                        <li>Verification Fee: ₹3050</li>
                        <li>Additional document fees will be calculated based on your request</li>
                    </ul>
                </div>
            </div>

            <div class="col-sm-12 row">
                <div class="col-sm-3">
                    <!-- <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label class="ff">
                                    Pay Mode
                                </mat-label>
                                <mat-select #select35 class="colorblack ff" formControlName="PayMode">
                                    <mat-select-filter *ngIf="select35.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="payModeList"
                                        (filteredReturn)="filteredpayModeList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredpayModeList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                    </div> totalAmount-->
                </div>
                <div class="col-sm-6 mrg mrg1" *ngIf="ExamCurrency == 'INR' ">
                    <span class="Text">Total Amount :</span><span class="currency-symbol">&#8377;{{TotalFee}}
                    </span>
                    <br>

                    <!-- <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">&#8377;</span>
                    </span>

                    <mat-form-field appearance="outline" class="example-full-width  col-sm-3">
                        <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                            formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">

                    </mat-form-field>
                    <mat-error class="margin_tp ml1" *ngIf="zeroError">
                        Enter Valid Amount.
                    </mat-error>
                    <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                        Amount Should Not Be Greater Than Remainig Amount.
                    </mat-error>
                    <mat-error class="margin_tp err"
                        *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                        Mandatory
                    </mat-error> -->
                </div>
                <div class="col-sm-6 mrg mrg1" *ngIf="ExamCurrency == 'USD' ">
                    <span class="Text">Total Amount :</span><span class="currency-symbol">${{totalAmount}}
                    </span>
                    <br>

                    <!-- <span class="Text mr3">Amount To Be Paid:<span class="currency-symbolTd">$</span>
                    </span>

                    <mat-form-field appearance="outline" class="example-full-width  col-sm-3">
                        <input onkeydown="return (event.keyCode!=13);" maxlength="8" class="color ff1" matInput
                            formControlName="TotalPaidAmount" (keyup)="onInputChange($event)">

                    </mat-form-field>
                    <mat-error class="margin_tp ml1" *ngIf="zeroError">
                        Enter Valid Amount.
                    </mat-error>
                    <mat-error class="margin_tp" *ngIf="shouldShowErrorMessage">
                        Amount Should Not Be Greater Than Remainig Amount.
                    </mat-error>
                    <mat-error class="margin_tp err"
                        *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.required">
                        Mandatory
                    </mat-error>
                    <mat-error class="margin_tp err"
                        *ngIf="FeeForm.controls['TotalPaidAmount'].touched && FeeForm.controls['TotalPaidAmount'].errors?.pattern">
                        Please Enter Valid Data.
                    </mat-error> -->
                </div>
            </div>
            <!-- <div class="col-sm-12"  *ngIf="ExamCurrency == 'INR' ">
                <span class="Text mrg5">Total Remaining Amount :</span>
                <span class="currency-symbolTd">&#8377;{{remainAmt}}</span>
            </div>
            <div class="col-sm-12"  *ngIf="ExamCurrency == 'USD' ">
                <span class="Text mrg5">Total Remaining Amount :</span><span
                    class="currency-symbol Textmrg1">${{remainAmt}}</span>
            </div> -->
            <div class="col-sm-12">
                <button type="button" *ngIf="payHistoryBtn" class="btn btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="openHistoryPopup()">
                    <span style="display: contents; align-items: center;">
                        <img width="25vh" src="../../assets/images/history.gif" style="margin-right: 5px;">
                        Payment History
                    </span>
                </button>
                <!-- <button type="button" *ngIf="submitButton" class="btn fr btn-primary btn-icon-text floatright mt-1 fr"
                    (click)="submitFeeTemplet()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 7px;">
                        Save
                    </span>
                </button> -->
                <!-- [disabled]="updateBtn"  -->
                <button type="button" *ngIf="submitButton" 
                class="btn fr btn-primary btn-icon-text floatright mt-1 fr" (click)="submitFeeTemplet()">
                    <!-- submitFeeTemplet() -->
                    <span style="display: contents; align-items: center;" >
                        <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                        Save
                    </span>
                </button>
                <button type="button" class="btn fr btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                    (click)="close()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/images/letter-x.gif" style="margin-right: 7px;">
                        Close
                    </span>
                </button>
            </div>
        </div>

    </div>
</form>